import { AxiosInstance } from "axios"
import { MeetingServiceOrder, Merchant, ReportDetails } from "./meetingServiceTypes"

export enum CompanyReportsMeetingServiceQuery {
    MEETING_SERVICE_ORDERS_FOR_COMPANY = "meeting-service-orders-for-company-reports",
}

type MerchantsForCompanyParams = Readonly<{
    companyId: number
}>

export type MerchantsForCompanyResponse = Readonly<{
    merchants: Merchant[]
}>

export async function fetchMerchantsForCompany(
    { companyId }: MerchantsForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MerchantsForCompanyResponse> {
    const url = `/companies/${companyId}/merchants`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

type MeetingServiceOrdersForCompanyParams = Readonly<{
    companyId: number
    orderId?: string
    pendingApproval?: boolean
    invoiceStatus?: string
    isBooked?: string
    startBookedDate?: string
    endBookedDate?: string
    startDeliveryDate?: string
    endDeliveryDate?: string
    merchantId?: string
    merchantIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethod?: string
    creditCardLast4?: string
    shopIds?: string
    satelliteIds?: string
    buyerPartyIds?: string
}>

export type MeetingServiceOrdersForCompanyResponse = Readonly<{
    reportDetails: ReportDetails
    orders: MeetingServiceOrder[]
}>

export async function fetchMeetingServiceOrdersForCompany(
    params: MeetingServiceOrdersForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MeetingServiceOrdersForCompanyResponse> {
    const { companyId, startBookedDate, endBookedDate, ...rest } = params
    const url = `/companies/${companyId}/accounting/meetingService/orders`

    const { data } = await axios.get(url, {
        // the endpoint scopes by booked date via startDate/endDate
        params: { ...rest, startDate: startBookedDate, endDate: endBookedDate },
        signal,
    })

    return data
}
